module.exports = __webpack_public_path__ + "r-v3/img/exam_sub_white.3791fcc7.svg";